import process from "process";
import { Buffer } from "buffer";

function addPolyfills() {
  window.Buffer = window.Buffer || Buffer;
  window.process = window.process || process;
}

export default addPolyfills;
